import styled from 'styled-components';
import { Input, Typography, Button, Modal, Radio } from 'antd';
import colors from '../../styles/colors';

const { Text } = Typography;
const { TextArea } = Input;

export const ModalCentralizada = styled(Modal)`
  justify-content: center;

  .ant-modal-content {
    border-radius: 2px;
    box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.16);
  }
`;

export const ContentModal = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 10px 0px 0px 0px;
`;

export const Title = styled(Text)`
  font-weight: bold;
  font-size: 18px;
  line-height: 22px;
  color: ${colors.blackText};
`;

export const InfoModal = styled(Text)`
  font-weight: bold;
  font-size: 14px;
  line-height: 16.41px;
  color: ${colors.greyText};
`;

export const ContainerButtons = styled.div`
  width: 100%;
  margin-top: 37px;
  display: flex;
  flex-direction: row;
  justify-content: space-evenly;
`;

export const ButtonCustom = styled(Button)`
  width: 120px;
  font-weight: bold;
  border-radius: 0;
  color: ${colors.branco};
  background: ${colors.verde};
  border: solid 1px ${colors.verde};
`;

export const TextAreaModal = styled(TextArea)`
  &:focus {
    border-color: ${colors.verde};
    box-shadow: 0 0 4px ${colors.verde};
  }
  &:hover {
    border-color: ${colors.verde};
  }
`;

export const OptionRadio = styled(Radio)`
  font-weight: 600;
  font-size: 12px;
  line-height: 22px;
  color: ${colors.greyText};
  .ant-radio-inner {
    border-color: ${colors.greyText};
    box-sizing: border-box;
    box-shadow: 0 0 0px ${colors.verde};
  }
  .ant-radio-inner::after {
    background-color: ${colors.verde};
    border-color: ${colors.verde};
    box-shadow: 0 0 0px ${colors.verde};
  }
  .ant-radio-checked .ant-radio-inner {
    border-color: ${colors.verde} !important ;
  }
  .ant-radio-checked .ant-radio-inner:after {
    background-color: ${colors.verde};
  }
  .ant-radio:hover .ant-radio-inner {
    border-color: ${colors.verde};
  }
  .ant-radio:focus .ant-radio-inner {
    box-shadow: 0 0 4px ${colors.verde};
  }
`;

export const ButtonCancel = styled(Button)`
  width: 120px;
  color: ${colors.verde} !important;
  border-radius: 0;
  background: ${colors.branco} !important;
  border: solid 1px ${colors.verde} !important;
  outline: none;
  font-weight: bold;
  margin: 0 5px;
  &:hover {
    background: ${colors.branco} !important;
    color: ${colors.verde};
    transform: scale(1.05);
  }
  &:focus {
    background: ${colors.branco} !important;
    color: ${colors.verde};
  }
`;
